<template>
  <div>
    <v-layout
      v-if="$vuetify.breakpoint.mdAndUp"
      style="height: calc(100vh - 44px)"
      fill-height
      wrap
    >
      <v-flex
        xs12
        style="height: calc(50vh - 44px)"
      >
        <v-row class="fill-height flex-nowrap">
          <v-flex
            md5
            xs12
            grow
          >
            <OverwatchCard>
              <v-layout
                column
                style="height: 100%"
              >
                <v-layout
                  v-if="actionBoxMode == 'book' || actionBoxMode == null"
                  pa-1
                  
                  style="height: 100%"
                >
                  <v-dialog
                    v-model="createBookingDialog"
                    persistent
                    eager
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                  >
                    <template v-slot:activator="{ on }">
                      <SmallBookForm
                        :zones="zones"
                        :booking-form="bookingForm"
                        :taxis="taxis"
                        :allow-return="true"
                        :expand="
                          function () {
                            filters = true
                            createBookingDialog = true;
                          }
                        "
                        @expand="
                          actionBoxMode == 'book'
                            ? (createBookingDialog = true)
                            : (editBookingDialog = true)
                        "
                        @close="close"
                        @madeBooking="madeBooking"
                        @updatedBooking="updatedBooking"
                        @locationsChanged="makeBookingLocationsChanged"
                      />
                    </template>
                    <v-card style="background-color: #f4f5f9">
                      <v-toolbar
                        class="cmr-app-bar rounded-0"
                      >
                        <v-btn
                          icon
                          dark
                          @click="closeCreateBookingDialog"
                        >
                          <v-icon color="white">
                            close
                          </v-icon>
                        </v-btn>
                        <v-toolbar-title>
                          Create Booking
                        </v-toolbar-title>
                        <v-spacer />
                      </v-toolbar>
                      <LargeBookForm
                        v-if="createBookingDialog == true"
                        :set-selected-booking="setSelectedBooking"
                        :set-selected-taxi="setSelectedTaxi"
                        :selected-taxi="selectedTaxi"
                        :selected-booking="selectedBooking"
                        :booking-form="bookingForm"
                        :filters="true"
                        @madeBooking="madeBooking"
                        @madeBookingLargeForm="madeBookingLargeForm"
                        @updatedBooking="updatedBooking"
                        @locationsChanged="makeBookingLocationsChanged"
                      />
                    </v-card>
                  </v-dialog>
                </v-layout>
                <v-flex
                  v-if="loadingEditBooking == true"
                  px-4
                  pb-1
                >
                  <v-progress-linear
                    indeterminate
                    color="yellow darken-2"
                  />
                </v-flex>
                <v-layout
                  v-if="actionBoxMode == 'edit'"
                  pa-1
                  style="height: 100%"
                >
                  <v-dialog
                    v-model="editBookingDialog"
                    fullscreen
                    hide-overlay
                    eager
                    transition="dialog-bottom-transition"
                  >
                    <!-- TODO SHOW ERROR FOR LOADING BOOKING -->
                    <template v-slot:activator="{ on }">
                      <v-layout>
                        <SmallBookForm
                          v-if="
                            (editBookingDialog == false ||
                              editBookingDialog == null) &&
                              loadingEditBooking == false &&
                              bookingForm != null
                          "
                          :zones="zones"
                          :booking-form="bookingForm"
                          :expand="
                            function () {
                              editBookingDialog = true;
                            }
                          "
                          :update-mode="true"
                          @expand="
                            actionBoxMode == 'book'
                              ? (createBookingDialog = true)
                              : (editBookingDialog = true)
                          "
                          @cancelledBooking="cancelledBooking"
                          @close="close"
                          @updatedBooking="updatedBooking"
                          @locationsChanged="makeBookingLocationsChanged"
                        />
                      </v-layout>
                    </template>
                    <v-card style="background-color: #f4f5f9">
                      <v-toolbar
                        dark
                        color="secondary"
                      >
                        <v-btn
                          icon
                          dark
                          @click="editBookingDialog = false"
                        >
                          <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>
                          Edit Booking
                          {{
                            bookingForm.booking.id != null
                              ? "#" +
                                bookingForm.booking.id +
                                " - " +
                                bookingForm.booking.state
                              : ""
                          }}
                        </v-toolbar-title>
                        <v-spacer />
                      </v-toolbar>
                      <v-flex
                        v-if="loadingEditBooking"
                        px-4
                        pb-1
                      >
                        <v-progress-linear
                          indeterminate
                          color="yellow darken-2"
                        />
                      </v-flex>
                      <LargeUpdateBookForm
                        v-if="
                          editBookingDialog == true &&
                            loadingEditBooking == false &&
                            bookingForm != null
                        "
                        :booking-form="bookingForm"
                        :update-mode="true"
                        @updatedBooking="updatedBooking"
                        @cancelledBooking="cancelledBooking"
                        @locationsChanged="makeBookingLocationsChanged"
                      />
                      <p v-if="editBookingError != null">
                        {{ editBookingError }}
                      </p>
                    </v-card>
                  </v-dialog>
                </v-layout>
                <v-layout
                  v-if="actionBoxMode == 'assign' && bookingToAssign != null"
                  pa-1
                  style="height: 100%"
                >
                  <AssignTrip
                    :key="bookingToAssign.id"
                    :booking="bookingFromID(bookingToAssign)"
                    :bookings="bookings"
                    :taxis="taxis"
                    :reassign-mode="
                      bookingFromID(bookingToAssign).state != 'booked'
                    "
                    @cancel="cancelAssign()"
                  />
                </v-layout>
                <v-layout
                  
                  v-if="
                    actionBoxMode != 'book' &&
                      actionBoxMode != 'edit' &&
                      actionBoxMode != 'assign'
                  "
                  justify-space-between
                  align-end
                  pb-2
                >
                  <v-layout
                    align-end
                  >
                    <p style="font-size: 12px; font-weight: 500">
                      &nbsp;&nbsp;{{ formatLastUpdateTime(lastUpdateTime) }}
                      {{ lastUpdateSecondsAgo(lastUpdateTime) }}
                      <span v-html="rideTypeAvailability()" />
                    </p>
                  </v-layout>
                  <v-flex shrink>
                    <v-row>
                      <v-flex px-1>
                        <v-btn
                          light
                          class="text-none"
                          small
                          :dark="
                            actionBoxMode == null || actionBoxMode == 'zones'
                          "
                          :color="
                            actionBoxMode == null || actionBoxMode == 'zones'
                              ? '#8268FC'
                              : ''
                          "
                          @click="makeBooking()"
                        >
                          Book Ride
                        </v-btn>
                      </v-flex>
                    </v-row>
                  </v-flex>
                </v-layout>
              </v-layout>
            </OverwatchCard>
          </v-flex>
          <v-flex
            pa-1
            pt-0
            pb-0
            pr-0
            md7
            xs12
            style="width: 100%"
          >
            <OverwatchCard style="width: 100%">
              <UpcomingTrips
                :set-selected-booking="setSelectedBooking"
                :selected-booking="selectedBooking"
                :taxis="taxis"
                :bookings="bookings"
                :hours-to-show="hoursToShow"
                :mode="mode"
                :pagination="pagination"
                @assign="enterAssignMode"
                @copy="enterCopyMode"
                @edit="enterEditMode"
                @changeHoursToShow="changeHoursToShow"
                @changeMode="changeMode"
                @changePage="changePage"
              />
            </OverwatchCard>
          </v-flex>
        </v-row>
      </v-flex>
      <v-flex
        xs12
        style="height: 50vh"
      >
        <v-layout
          fill-height
          :wrap="$vuetify.breakpoint.smAndDown"
        >
          <v-flex
            pt-1
            md3
            xs8
            grow
          >
            <OverwatchMap
              ref="taxiMap"
              :taxis="taxis"
              :bookings="bookings"
              :set-selected-taxi="setSelectedTaxi"
              style="height: 100%; width: 100%"
              :customers-for-map="customersForMap"
              :show-customers-in-app="true"
              :enable-drag-to-update="true"
              :zone="bookingForm != null ? bookingForm.booking.zone : null"
              @placechanged="locationChanged"
            />
          </v-flex>
          <v-flex
            xs4
            md2
          >
            <TaxiList
              v-if="!showZones"
              :set-selected-taxi="setSelectedTaxi"
              :selected-taxi="selectedTaxi"
              :ride-types="rideTypes"
              :taxis="taxis"
              :ride-type-etas="rideTypeEtas"
              :bookings="bookings"
              @editBooking="enterEditMode"
              @showZones="showZones = true"
            />
            <ZoneList
              v-if="showZones"
              :set-selected-taxi="setSelectedTaxi"
              :selected-taxi="selectedTaxi"
              :ride-types="rideTypes"
              :taxis="taxis"
              :ride-type-etas="rideTypeEtas"
              :bookings="bookings"
              :zones="zones"
              @editBooking="enterEditMode"
              @showZones="showZones = false"
            />
            <v-layout
              align-end
            >
              <p style="font-size: 12px; font-weight: 500">
                &nbsp;&nbsp;{{ formatLastUpdateTime(lastUpdateTime) }}
                {{ lastUpdateSecondsAgo(lastUpdateTime) }}
                <span v-html="rideTypeAvailability()" />
              </p>
            </v-layout>
          </v-flex>
          <v-flex
            pa-1
            pt-1
            pb-0
            pr-0
            md7
            xs12
            grow
          >
            <OverwatchCard>
              <v-layout column>
                <ActiveTrips
                  :set-selected-booking="setSelectedBooking"
                  :set-selected-taxi="setSelectedTaxi"
                  :selected-taxi="selectedTaxi"
                  :selected-booking="selectedBooking"
                  :taxis="taxis"
                  :bookings="bookings"
                  :history="history"
                  :no-driver-available-bookings="noDriverAvailableBookings"
                  :hours-to-show="hoursToShowHistory"
                  @reassign="enterAssignMode"
                  @edit="enterEditMode"
                  @copy="enterCopyMode"
                  @changeHoursToShow="changeHoursToShowHistory"
                />
              </v-layout>
            </OverwatchCard>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- V ELSE
    
    
    MOBILE BREAK POINT
    
    
     -->
    <v-col
      v-else
      style="padding-left: 0px !important; padding-top: 0px !important"
    >
      <v-flex xs12>
        <v-flex
          pt-3
          style="height: 400px"
        >
          <OverwatchCard>
            <v-layout
              column
              style="height: 100%"
            >
              <v-layout
                v-if="
                  actionBoxMode == null ||
                    (actionBoxMode != 'zones' &&
                    actionBoxMode != 'book' &&
                    actionBoxMode != 'edit' &&
                    actionBoxMode != 'assign')
                "
                pl-2
                pr-2
                pt-2
                style="height: 100%"
              >
                <TaxiList
                  :set-selected-taxi="setSelectedTaxi"
                  :selected-taxi="selectedTaxi"
                  :ride-types="rideTypes"
                  :taxis="taxis"
                  :ride-type-etas="rideTypeEtas"
                  :bookings="bookings"
                  @editBooking="enterEditMode"
                />
              </v-layout>
              <v-layout
                v-if="actionBoxMode == 'zones'"
                pl-2
                pr-2
                pt-2
                style="height: 100%"
              >
                <ZoneList
                  :set-selected-taxi="setSelectedTaxi"
                  :selected-taxi="selectedTaxi"
                  :ride-types="rideTypes"
                  :taxis="taxis"
                  :ride-type-etas="rideTypeEtas"
                  :bookings="bookings"
                  :zones="zones"
                />
              </v-layout>
              <v-layout
                v-if="actionBoxMode == 'book'"
                pa-1
                style="height: 100%"
              >
                <v-dialog
                  v-model="createBookingDialog"
                  persistent
                  eager
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
                >
                  <template v-slot:activator="{ on }">
                    <SmallBookForm
                      :zones="zones"
                      :booking-form="bookingForm"
                      :taxis="taxis"
                      :expand="
                        function () {
                          createBookingDialog = true;
                        }
                      "
                      @expand="
                        actionBoxMode == 'book'
                          ? (createBookingDialog = true)
                          : (editBookingDialog = true)
                      "
                      @close="close"
                      @madeBooking="madeBooking"
                      @updatedBooking="updatedBooking"
                      @locationsChanged="makeBookingLocationsChanged"
                    />
                  </template>
                  <v-card style="background-color: #f4f5f9">
                    <v-toolbar
                      dark
                      color="#287B00"
                    >
                      <v-btn
                        icon
                        dark
                        @click="closeCreateBookingDialog"
                      >
                        <v-icon color="white">
                          close
                        </v-icon>
                      </v-btn>
                      <v-toolbar-title>Create Booking</v-toolbar-title>
                      <v-spacer />
                    </v-toolbar>
                    <LargeBookForm
                      v-if="createBookingDialog == true"
                      :booking-form="bookingForm"
                      @madeBookingLargeForm="madeBookingLargeForm"
                      @updatedBooking="updatedBooking"
                      @locationsChanged="makeBookingLocationsChanged"
                    />
                  </v-card>
                </v-dialog>
              </v-layout>
              <v-flex
                v-if="loadingEditBooking == true"
                px-4
                pb-1
              >
                <v-progress-linear
                  indeterminate
                  color="yellow darken-2"
                />
              </v-flex>
              <v-layout
                v-if="actionBoxMode == 'edit'"
                pa-1
                style="height: 100%"
              >
                <v-dialog
                  v-model="editBookingDialog"
                  fullscreen
                  hide-overlay
                  eager
                  transition="dialog-bottom-transition"
                >
                  <!-- TODO SHOW ERROR FOR LOADING BOOKING -->
                  <template v-slot:activator="{ on }">
                    <v-layout>
                      <SmallBookForm
                        v-if="
                          (editBookingDialog == false ||
                            editBookingDialog == null) &&
                            loadingEditBooking == false &&
                            bookingForm != null
                        "
                        :taxis="taxis"
                        :zones="zones"
                        :booking-form="bookingForm"
                        :expand="
                          function () {
                            editBookingDialog = true;
                          }
                        "
                        :update-mode="true"
                        @expand="
                          actionBoxMode == 'book'
                            ? (createBookingDialog = true)
                            : (editBookingDialog = true)
                        "
                        @cancelledBooking="cancelledBooking"
                        @close="close"
                        @updatedBooking="updatedBooking"
                        @locationsChanged="makeBookingLocationsChanged"
                      />
                    </v-layout>
                  </template>
                  <v-card style="background-color: #f4f5f9">
                    <v-toolbar
                      dark
                      color="#287B00"
                    >
                      <v-btn
                        icon
                        dark
                        @click="editBookingDialog = false"
                      >
                        <v-icon>close</v-icon>
                      </v-btn>
                      <v-toolbar-title>
                        Edit Booking
                        {{
                          bookingForm.booking.id != null
                            ? "#" +
                              bookingForm.booking.id +
                              " - " +
                              bookingForm.booking.state
                            : ""
                        }}
                      </v-toolbar-title>
                      <v-spacer />
                    </v-toolbar>
                    <v-flex
                      v-if="loadingEditBooking"
                      px-4
                      pb-1
                    >
                      <v-progress-linear
                        indeterminate
                        color="yellow darken-2"
                      />
                    </v-flex>
                    <LargeUpdateBookForm
                      v-if="
                        editBookingDialog == true &&
                          loadingEditBooking == false &&
                          bookingForm != null
                      "
                      :booking-form="bookingForm"
                      :update-mode="true"
                      :filters="filters"
                      @updatedBooking="updatedBooking"
                      @cancelledBooking="cancelledBooking"
                      @locationsChanged="makeBookingLocationsChanged"
                    />
                    <p v-if="editBookingError != null">
                      {{ editBookingError }}
                    </p>
                  </v-card>
                </v-dialog>
              </v-layout>
              <v-layout
                v-if="actionBoxMode == 'assign' && bookingToAssign != null"
                pa-1
                style="height: 100%"
              >
                <AssignTrip
                  :key="bookingToAssign.id"
                  :booking="bookingFromID(bookingToAssign)"
                  :bookings="bookings"
                  :taxis="taxis"
                  :reassign-mode="
                    bookingFromID(bookingToAssign).state != 'booked'
                  "
                  @cancel="cancel()"
                />
              </v-layout>
              <v-layout
                
                v-if="
                  actionBoxMode != 'book' &&
                    actionBoxMode != 'edit' &&
                    actionBoxMode != 'assign'
                "
                justify-space-between
                align-end
                pb-2
              >
                <v-layout
                  align-end
                >
                  <p style="font-size: 12px; font-weight: 500">
                    &nbsp;&nbsp;{{ formatLastUpdateTime(lastUpdateTime) }}
                    {{ lastUpdateSecondsAgo(lastUpdateTime) }}
                    <span v-html="rideTypeAvailability()" />
                  </p>
                </v-layout>
                <v-flex shrink>
                  <v-row>
                    <v-flex px-1>
                      <v-btn
                        light
                        class="text-none"
                        small
                        @click="
                          actionBoxMode == 'zones'
                            ? (actionBoxMode = null)
                            : (actionBoxMode = 'zones')
                        "
                      >
                        {{
                          actionBoxMode == null ? "Zones" : "Ride Types"
                        }}
                      </v-btn>
                    </v-flex>
                    <v-flex px-1>
                      <v-btn
                        light
                        class="text-none"
                        small
                        :dark="
                          actionBoxMode == null || actionBoxMode == 'zones'
                        "
                        :color="
                          actionBoxMode == null || actionBoxMode == 'zones'
                            ? '#8268FC'
                            : ''
                        "
                        @click="makeBooking()"
                      >
                        Book Ride
                      </v-btn>
                    </v-flex>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-layout>
          </OverwatchCard>
        </v-flex>
      </v-flex>
      <v-flex
        pt-3
        style="width: 100%; height: 400px"
      >
        <OverwatchCard>
          <UpcomingTrips
            :set-selected-booking="setSelectedBooking"
            :selected-booking="selectedBooking"
            :taxis="taxis"
            :bookings="bookings"
            :hours-to-show="hoursToShow"
            :mode="mode"
            :pagination="pagination"
            @assign="enterAssignMode"
            @copy="enterCopyMode"
            @edit="enterEditMode"
            @changeHoursToShow="changeHoursToShow"
            @changeMode="changeMode"
            @changePage="changePage"
          />
        </OverwatchCard>
      </v-flex>
      <v-flex
        pt-3
        style="width: 100%; height: 400px"
      >
        <OverwatchMap
          ref="taxiMap"
          :taxis="taxis"
          :bookings="bookings"
          :set-selected-taxi="setSelectedTaxi"
          style="height: 100%; width: 100%"
          :customers-for-map="customersForMap"
          :show-customers-in-app="true"
          :enable-drag-to-update="true"
          :zone="bookingForm != null ? bookingForm.booking.zone : null"
          @placechanged="locationChanged"
        />
      </v-flex>
      <v-flex
        pt-3
        style="width: 100%; height: 400px"
      >
        <OverwatchCard>
          <ActiveTrips
            :set-selected-booking="setSelectedBooking"
            :set-selected-taxi="setSelectedTaxi"
            :selected-taxi="selectedTaxi"
            :selected-booking="selectedBooking"
            :taxis="taxis"
            :bookings="bookings"
            :history="history"
            :hours-to-show="hoursToShowHistory"
            @reassign="enterAssignMode"
            @edit="enterEditMode"
            @copy="enterCopyMode"
            @changeHoursToShow="changeHoursToShowHistory"
          />
        </OverwatchCard>
      </v-flex>
    </v-col>
    <v-row justify="center">
      <v-dialog
        v-model="promptDialog"
        persistent
        max-width="290"
      >

        <v-card>
          <v-card-title class="text-h5">
            Booking Made
          </v-card-title>
          <v-card-text>
            {{promptText}}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="proceedBookingProcess(false)"
            >
              No
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="proceedBookingProcess(true)"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import Home from "@/components/Home.vue";
import OverwatchCard from "@/components/widget/OverwatchCard.vue";
import OverwatchMap from "@/components/overwatch/OverwatchMap.vue";

import TaxiList from "@/components/overwatch/TaxiList.vue";
import ZoneList from "@/components/overwatch/ZoneList.vue";

import AssignTrip from "@/components/booking/AssignTrip.vue";

import SmallBookForm from "@/components/booking/SmallBookForm.vue";

import LargeBookForm from "@/components/booking/form/NewLargeBookForm.vue";
import LargeUpdateBookForm from "@/components/booking/form/LargeUpdateBookForm.vue";

import UpcomingTrips from "@/components/overwatch/UpcomingTrips.vue";
import ActiveTrips from "@/components/overwatch/ActiveTrips.vue";

import { BookingForm } from "@/components/util/BookingForm.js";

import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

import moment from "moment";
import OverwatchFilterPopOver from '@/components/overwatch/filters/OverwatchFilterPopOver'

global.jQuery = require("jquery");
var $ = global.jQuery;

export default {
  name: "Overwatch",
  components: {
    OverwatchFilterPopOver,
    Home,
    OverwatchCard,
    OverwatchMap,
    TaxiList,
    UpcomingTrips,
    ActiveTrips,
    SmallBookForm,
    LargeBookForm,
    AssignTrip,
    ZoneList,
    LargeUpdateBookForm
  },
  data: function () {
    return {
      promptDialog: false,
      makeReturn: false,
      promptText: "",
      showZones: false,
      lastUpdateTime: null,
      filters: false,
      createBookingDialog: false,
      editBookingDialog: false,
      loadingEditBooking: false,
      editBookingError: null,
      actionBoxMode: null,
      loading: true,
      rideTypes: [],
      zones: [],
      taxis: [],
      history: [],
      bookings: [],
      noDriverAvailableBookings: [],
      rideTypeEtas: null,
      selectedTaxi: -1,
      selectedBooking: -1,
      bookingForm: null,
      bookingToAssign: null,
      hoursToShow: 18,
      hoursToShowHistory: 4,
      getInformationTimer: null,
      defaultTaxiList: null,
      getCustomersFromMapTimer: null,
      customersForMap: [],
      mode: "default",
      offset: 0,
      count: 50,
      numPages: -1,
      pagination: {
        page: 1,
        itemsPerPage: 50,
        sortBy: null,
        pageStart: 0,
        pageStop: 0,
        pageCount: 0,
        itemsLength: 0,
      },
    };
  },
  computed: {
    isUnconfirmedUpdate () {
      return this.$store.getters['unconfirmedBooking/isUnConfirmedUpdate']
    },
    includeUnconfirmedBookings () {
      return this.$store.getters['overwatch/getIncludeUnconfirmedBookings']
    },
    bookingTypesFilter () {
      return this.$store.getters['overwatch/getBookingTypesFilter']
    },
    customerIdFilter () {
      return this.$store.getters['overwatch/getCustomerIdFilter']
    },
    mapCenter () {
      return this.$store.getters['availabilityRegion/getCenter']
    },
    isMenuOpen () {
      let values = Object.values(this.$store.state.bookingMenu)
      let isOpen =  values.find(val => {
        return val == true
      })
      if (isOpen) {
        return true
      }
      return false
    },
  },
  watch: {
    filters () {
      if (!this.filters) {
        var vm = this;
        this.getInformationTimer = setTimeout(function () {
          vm.getInformation();
          // vm.getRideTypes();
          vm.getZones();
        }, 1500);
      } else {
        this.getInformationTimer = null
        clearTimeout(this.getInformationTimer);
      }
    },
    createBookingDialog: function (val) {
      console.log("Dialog changed " + val);

      var vm = this;
    },
    actionBoxMode: function (val) {
      console.log(val);
      if (val == null || val == "zones") {
        this.$cookies.set("defaultTaxiList", val, Infinity);
      }
    },
  },
  beforeMount: function () {
    if (!this.$cookies.isKey("hoursToShow")) {
      this.$cookies.set("hoursToShow", 3, Infinity);
    }
    this.hoursToShow = parseInt(this.$cookies.get("hoursToShow"));

    if (!this.$cookies.isKey("hoursToShowHistory")) {
      this.$cookies.set("hoursToShowHistory", 3, Infinity);
    }
    this.hoursToShowHistory = parseInt(this.$cookies.get("hoursToShowHistory"));

    if (!this.$cookies.isKey("defaultTaxiList")) {
      this.$cookies.set("defaultTaxiList", null, Infinity);
    }
    this.defaultTaxiList = this.$cookies.get("defaultTaxiList");
    console.log("Default taxi list before mount " + this.defaultTaxiList);
    this.actionBoxMode = this.defaultTaxiList;
  },
  created: function () {},
  beforeDestroy: function () {
    clearTimeout(this.getInformationTimer);
    this.getInformationTimer = null;

    clearTimeout(this.getCustomersFromMapTimer);
    this.getCustomersFromMapTimer = null;

    console.log("Overwatch Destroyed")
    this.actionBoxMode = null;
  },
  mounted: function () {
    var vm = this;
    // this.$refs.taxiMap.recenter();

    this.getDriverGroups();

    this.getCustomersFromMapTimer = setInterval(function () {
      vm.getCustomersForMap();
    }, 1000);

    if (!this.filters) {
      this.getInformationTimer = setTimeout(function () {
        vm.getInformation();
        vm.getRideTypes();
        vm.getZones();
      }, 1500);
    }

    setTimeout(function () {
      $(document).on("click", function (e) {
        // console.log($(e.target)[0].id);
        // console.log($(e.target).attr("class"));

        var id = $(e.target)[0].id;

        if (id == "gridcontainer" || $(e.target).attr("class") == "flex") {
          // Clicked on blank space
          vm.selectedBooking = -1;
          vm.setSelectedTaxi(-1);
        }
      });
    }, 5000);

  },
  methods: {
    getDriverGroups: async function() {
      try {
        var url = `${this.$store.state.apiUrl}/driver_group/all`;

        let response = await axios.get(url, {
          params: {}
        });

        this.$store.state.driverGroups = response.data;
      } catch (e) {
        console.log(e);
      }
      
    },
    proceedBookingProcess (proceed) {
      if (proceed) {
        if (this.makeReturn) {
          this.makeReturnBooking()
          this.promptDialog = false
        } else {
          this.copyBooking()
        }
      } else {
        // this.cancel()
        this.promptDialog = false
        this.bookingForm = null
        this.createBookingDialog = false
      }
    },
    makeReturnBooking () {
      this.bookingForm.swapPickupAndDestination();
      this.continueBookingProcess()
    },
    copyBooking () {
      this.promptDialog = false
      this.continueBookingProcess()
    },
    continueBookingProcess () {
      // this.actionBoxMode = this.defaultTaxiList;
      this.$refs.taxiMap.clear();
      this.$refs.taxiMap.recenter();
      // this.makeBooking(this.makeReturn);
    },
    changePage: function (page) {

      if (page == 1) {
        this.pagination.page += 1;
      } else if (page == -1) {
        this.pagination.page -= 1;
      }

      if (this.pagination.page < 0) {
        this.pagination.page = 0;
      } else if (this.pagination.page > this.numPages) {
        this.pagination.page = this.numPages;
      }

      // clearTimeout(this.getInformationTimer);

      // var vm = this;
      // this.getInformationTimer = setTimeout(function () {
      //   vm.getInformation();
      // }, 1500);

      console.log("Current Page = " + this.pagination.page);
    },
    changeMode: function (mode) {
      this.mode = mode;
    },
    locationChanged: function (loc) {
      this.bookingForm.getCostEstimate();
    },
    changeHoursToShow(hours) {
      this.hoursToShow = hours;
      this.$cookies.set("hoursToShow", hours, Infinity);
    },
    changeHoursToShowHistory(hours) {
      this.hoursToShowHistory = hours;
      this.$cookies.set("hoursToShowHistory", hours, Infinity);
    },
    rideTypeAvailability: function () {
      var html = "";

      return html;
    },
    abbreviate: function (str1) {
      var split_names = str1.trim().split(" ");
      if (split_names.length > 1) {
        return split_names[0] + " " + split_names[1].charAt(0) + ".";
      }
      return split_names[0];
    },
    lastUpdateSecondsAgo: function (l) {
      if (document.hidden) {
        return '0 seconds ago';
      }
      if (l) {
        return (
            "(" +
            ((new Date().getTime() - l.getTime()).toFixed() / 1000).toFixed(0) +
            " seconds ago" +
            ")"
        );
      }
    },
    formatLastUpdateTime: function (l) {
      //YYYY-MM-DD
      return "Last Update " + moment(l).format("HH:mm:ss");
    },
    closeCreateBookingDialog: function () {
      this.filters = false

      this.createBookingDialog = false;
      var vm = this;
      this.$forceUpdate()
      vm.$nextTick(function () {
        this.createBookingDialog = false;
        vm.$forceUpdate();
      });
    },
    bookingFromID: function (id) {
      return this.bookings.find(function (b) {
        return b.id == id;
      });
    },
    madeBooking: function (makeReturn) {
      console.log("Made booking");
      this.createBookingDialog = null;

      console.log(makeReturn);
      
      if (!makeReturn) {
        this.bookingForm = null;
      } else {
        alert("Booking is made. Now make return booking")
        this.bookingForm.swapPickupAndDestination();
      }

      this.actionBoxMode = this.defaultTaxiList;

      this.$refs.taxiMap.clear();
      this.$refs.taxiMap.recenter();
      this.makeBooking(makeReturn);
    },
    madeBookingLargeForm: function (makeReturn) {

      this.makeReturn = makeReturn
      if (!makeReturn) {
        this.promptText = "Booking is made. Would you like to make another Booking?"
        this.promptDialog = true
        return;
        this.bookingForm = null;
      } else {
        this.promptText = "Outbound booking is created. Now please create return booking. "
        this.promptDialog = true
      }
    },
    updatedBooking: function () {
      if (this.isUnconfirmedUpdate) {
        this.$store.dispatch('unconfirmedBooking/confirm', this.bookingForm.booking.id).then(res => {
          this.$snackbar.success('Booking confirmed')
          this.$store.commit('unconfirmedBooking/setUnconfirmedUpdate', false)
        })
      }
      this.editBookingDialog = null;
      this.bookingForm = null;
      this.actionBoxMode = this.defaultTaxiList;

      this.$refs.taxiMap.clear();
      this.$refs.taxiMap.recenter();

      this.makeBooking();
    },
    cancelledBooking: function () {
      this.editBookingDialog = null;
      this.bookingForm = null;
      this.actionBoxMode = this.defaultTaxiList;

      this.$refs.taxiMap.clear();
      this.$refs.taxiMap.recenter();

      this.makeBooking();
    },
    makeBookingLocationsChanged: function (val) {
      console.log("Updating map");
      this.$refs.taxiMap.zoomToMakingBooking(this.bookingForm.booking);
    },
    makeBooking: function (bookReturn) {

      console.log("Showing booking action box please what are you doing", bookReturn);

      if (bookReturn != true) {
        this.bookingForm = new BookingForm(this.rideTypes, "", this.$store);
      }

      var vm = this;

      vm.$nextTick(async function() {
        vm.actionBoxMode = "book";
      });
    },
    cancel: function () {

      console.log("Cancel");

      this.actionBoxMode = this.defaultTaxiList;
      this.bookingToAssign = null;
      this.bookingForm = null;

      this.loadingEditBooking = false;
      this.editBookingError = null;

      this.$refs.taxiMap.clear();
    },
    close: function (cancel) {
        this.cancel();
      var vm = this;

       vm.$nextTick(function () {
        vm.makeBooking();
      });
    },
    cancelAssign: function () {
      this.cancel();

      this.makeBooking();
    },
    enterAssignMode: function (b) {
      this.cancel();

      var vm = this;

      vm.$nextTick(function () {
        vm.actionBoxMode = "assign";
        vm.bookingToAssign = b;
      });
    },
    enterCopyMode: function (booking) {
      this.cancel();

      var vm = this;

      vm.$nextTick(function () {
        vm.bookingForm = new BookingForm(vm.rideTypes, "", vm.$store);
        vm.bookingForm.copy(booking);
        vm.actionBoxMode = "book";
      });
    },
    async enterEditMode(b) {
      this.cancel();

      var vm = this;

      this.loadingEditBooking = true;

      vm.$nextTick(async function () {
        vm.actionBoxMode = "edit";
        console.log("EDIT MODE ");

        var booking = await vm.getBookingForEdit(b);

        console.log("booking");
        console.log(booking);

        if (typeof booking === "string") {
          console.log("Error for edit booking");
          this.editBookingError = booking;
        } else {
          var bookingUser = BookingForm.jsonToBookingFormBookingUser(booking);

          this.bookingForm = new BookingForm(
            this.rideTypes,
            bookingUser,
            this.$store
          );

          this.$refs.taxiMap.zoomToMakingBooking(this.bookingForm.booking);
        }

        this.loadingEditBooking = false;
      });
    },
    setSelectedBooking: function (bookingID, taxiID) {
      if (bookingID != -1) {
        this.setSelectedTaxi(-1);
      }

      if (this.selectedBooking == bookingID) {
        console.log("resetting");
        this.selectedBooking = -1;
        return;
      } else {
        this.selectedBooking = bookingID;
      }

      console.log("Booking ID " + bookingID);
      console.log("Taxi ID " + taxiID);

      var taxi = null;

      if (taxiID != null) {
        taxi = this.taxis.find(function (t) {
          return t.id == taxiID;
        });

        if (taxi != null) {
          this.selectedTaxi = taxi.id;
          console.log("Got taxi " + this.selectedTaxi);
        }

        try {
          if (this.selectedTaxi != -1) {
            var elem = document.getElementById(this.selectedTaxi);
            elem.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "nearest",
            });
          } else {
            // var elem = document.getElementById("activeTable-header-row");
            // elem.scrollIntoView(true);
          }
        } catch (e) {
          console.log(e);
          // taxi had no booking
        }
      }

      var booking = null;

      if (bookingID != -1) {
        booking = this.bookings.find(function (b) {
          return b.id == bookingID;
        });
      }

      if (booking == null) {
        console.log("Booking was null");
        return;
      }

      this.$refs.taxiMap.updateMarkers(this.selectedTaxi);
      this.$refs.taxiMap.zoomToBookingTaxi(booking, taxi);
    },
    setSelectedTaxi: function (taxiID) {
      if (taxiID != -1) {
        this.setSelectedBooking(-1);
      }

      console.log(taxiID);

      if (this.selectedTaxi == taxiID) {
        this.selectedTaxi = -1;
      } else {
        this.selectedTaxi = taxiID;
      }

      try {
        if (this.selectedTaxi != -1) {
          var elem = document.getElementById(this.selectedTaxi);
          elem.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest",
          });
        } else {
          // var elem = document.getElementById("activeTable-header-row");
          // elem.scrollIntoView(true);
        }
      } catch (e) {
        console.log(e);
        // taxi had no booking
      }

      try {
        // console.log(this);
        this.$refs.taxiMap.updateMarkers(this.selectedTaxi);
        this.$refs.taxiMap.zoomToTaxi(this.selectedTaxi);
      } catch (e) {
        console.log(e);
      }

      // highlight in table

      // highlight in summary
    },
    getInformation: async function () {
     
      this.loading = true;
      
      if (document.hidden) {
        if (!this.filters) {
          if (this.getInformationTimer != null) {
            setTimeout(this.getInformation.bind(this), 1000);
          }
    
        }
        return;
      }

      try {
        
          var url = `${
            this.$store.state.apiUrl
          }/overwatch/getInformation?hoursToShow=${
            this.hoursToShow == null ? 2 : this.hoursToShow
          }&historyToReturn=${
            this.hoursToShowHistory == null ? 0 : this.hoursToShowHistory
          }&mode=${this.mode}&count=${this.count}&offset=${
            (this.pagination.page - 1) * this.count
          }`;
          
          if (this.includeUnconfirmedBookings) {
            url += `&includeUnconfirmedBookings=${true}`
          }
          
          if (!this.includeUnconfirmedBookings) {
            url += `&includeUnconfirmedBookings=${false}`
          }

          // if (this.bookingTypesFilter) {
          //   url += `&bookingTypes=${this.bookingTypesFilter}`
          // }

          if (this.customerIdFilter) {
            url += `&customerId=${this.customerIdFilter}`
          }
          
  
          let response = await axios.get(url, {
            params: {},
          });
  
          // console.log(response.data);
  
          this.lastUpdateTime = new Date();
  
          // console.log(
          //   "Updating the information",
          //   "Taxis " + response.data.taxis.length,
          //   "Bookings " + response.data.jobs.length,
          //   "History " + response.data.history.length
          // );
  
          this.taxis.length = 0;
          this.bookings.length = 0;
          this.history.length = 0;
          this.noDriverAvailableBookings = [];
  
          this.taxis.push(...response.data.taxis);
          this.bookings.push(...response.data.jobs);
          console.log('booking with via info ', this.bookings[0])
          this.history.push(...response.data.history);
          if (response.data.no_driver_available_jobs && response.data.no_driver_available_jobs.length) {
            this.noDriverAvailableBookings.push(...response.data.no_driver_available_jobs);
          }
  
          // pagination: {
          //     page: 1,
          //     itemsPerPage: 50,
          //     sortBy: null,
          //     pageStart: 10,
          //     pageStop: 22,
          //     pageCount: 30,
          //     itemsLength: 30,
          //   },
  
          if (this.mode != "default") {
            this.upcomingBookingCount = response.data.upcomingBookingCount;
            this.pagination.pageCount = Math.ceil(
              response.data.upcomingBookingCount / this.pagination.itemsPerPage
            );
            this.numPages = Math.ceil(
              response.data.upcomingBookingCount / this.pagination.itemsPerPage
            );
            this.pagination.itemsLength = this.upcomingBookingCount;
            this.pagination.pageStart = (this.pagination.page - 1) * this.count;
            this.pagination.pageStop =
              this.pagination.pageStart + response.data.upcomingBookingPageLength;
          }
  
          if (this.history == null) {
            this.history = [];
          }
  
          this.rideTypeEtas = response.data.ride_type_eta;
  
          try {
            // console.log(this);
            this.$refs.taxiMap.updateMarkers(this.selectedTaxi);
          } catch (error) {
            console.log('error in overwatch')
            console.log(error);
          }
          
          console.log('error left behind')
        if (!this.filters) {
          if (this.getInformationTimer != null) {
            setTimeout(this.getInformation.bind(this), 2000);
          }
        }
      } catch (error) {
        this.loading = false;

        if (!this.filters) {
          if (this.getInformationTimer != null) {
            setTimeout(this.getInformation.bind(this), 2000);
          }

        }

        console.log("Failed to get information " + error);
        // console.log(error.stack)
      }
    },
    getCustomersForMap: async function () {
      // console.log("Getting customers for map");
      if (document.hidden) {
        return;
      }

      try {
        var url = `${this.$store.state.apiUrl}/customer_map/getInformation?inactivityCutoffSeconds=60`;

        let response = await axios.get(url, {
          params: {},
        });

        // console.log(response.data);

        this.customersForMap = response.data.customer_map_array;

        try {
          // console.log(this);
          this.$refs.taxiMap.updateMarkers(this.selectedTaxi);
        } catch (error) {
          console.log(error);
        }
      } catch (error) {
        this.loading = false;

        console.log("Failed to get customers for map " + error);
      }
    },
    getRideTypes: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/ride_types/all`;

        let response = await axios.get(url, {
          params: {},
        });

        this.rideTypes = response.data;
        this.makeBooking();

        console.log("got ride types");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ride types " + error);
      }
    },
    getZones: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/zones/all`;

        let response = await axios.get(url, {
          params: {},
        });

        this.zones = response.data.zones;
        this.$store.state.use_zone_based_dispatch =
          response.data.use_zone_based_dispatch;

        console.log("got zones");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get zones " + error);
      }
    },
    async getBookingForEdit(bookingID) {
      try {
        var url = `${this.$store.state.apiUrl}/booking/${bookingID}/get`;

        let response = await axios.get(url, {
          params: {},
        });

        this.loadingEditBooking = false;

        if (response.error == null || response.error == "no_error") {
          return response.data;
        } else {
          return response.data.error;
        }
      } catch (error) {
        this.loadingEditBooking = false;

        console.log("Failed to get booking " + error);
        return "Unknown Error";
      }
    },
  },
};
</script>
